import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import "./GetStart.css";

import bgImage from "../../assets/get-start.png";
import Logo from "../../assets/get-start-logo.png";

const languages = [
  "മലയാളം",
  "मराठी",
  "ગુજરાતી",
  "தமிழ்",
  "ಕನ್ನಡ",
  "ਪੰਜਾਬੀ",
  "हिन्दी",
  "বাংলা",
  "తెలుగు",
];

const GetStart = () => {
  const navigate = useNavigate();
  const [radius, setRadius] = useState(170);

  const updateRadius = () => {
    const width = window.innerWidth;

    if (width <= 480) setRadius(90);
    else if (width <= 768) setRadius(140);
    else setRadius(170);
  };

  useEffect(() => {
    updateRadius();
    window.addEventListener("resize", updateRadius);

    return () => window.removeEventListener("resize", updateRadius);
  }, []);

  return (
    <div
      className="getstart-page"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="getstart-logo-circle-wrapper">
        <div className="getstart-circle-wrapper">
          {languages.map((lang, i) => {
            const angle = (i * 360) / languages.length;
            return (
              <span
                key={i}
                className="getstart-circle-text"
                style={{
                  transform: `rotate(${angle}deg) translate(${radius}px) rotate(-${angle}deg)`,
                }}
              >
                {lang}
              </span>
            );
          })}
        </div>
        <img src={Logo} className="getstart-main-logo" alt="Skill Edition" />
      </div>

      <div className="getstart-bottom-text">
        <h5>Welcome to Skilledition</h5>
        <p>
          Join a community where students learn and tutors inspire start your
          journey now.
        </p>
        <Button
          className="getstart-btn"
          onClick={() => navigate("/choose-role")}
        >
          Get Started
        </Button>
      </div>
    </div>
  );
};

export default GetStart;
